/**
 * Persistent queue store (010 FR-001/002).
 *
 * Wraps PlatformIO.localStore.records so JobRecords survive app restarts
 * (desktop SQLite / web IndexedDB). The QueueManager (shared-ui) owns the
 * lifecycle logic; this is just durable persistence.
 */
import type { LocalStore } from "../platform-io.js";
import type { JobRecord } from "../telemetry/types.js";

const COLLECTION = "queue.jobs";

export class QueueStore {
  constructor(private readonly store: LocalStore) {}

  async save(job: JobRecord): Promise<void> {
    await this.store.records.put(COLLECTION, job.jobId, job);
  }

  async load(jobId: string): Promise<JobRecord | undefined> {
    return this.store.records.get<JobRecord>(COLLECTION, jobId);
  }

  /** All jobs, ordered by queue position. */
  async all(): Promise<JobRecord[]> {
    const jobs = await this.store.records.all<JobRecord>(COLLECTION);
    return jobs.sort((a, b) => a.position - b.position);
  }

  async remove(jobId: string): Promise<void> {
    await this.store.records.remove(COLLECTION, jobId);
  }

  async clear(): Promise<void> {
    await this.store.records.clear(COLLECTION);
  }
}
